const UiDatePickerPropsOption = {
  classExtraName: { type: String, default: "" },
  //* 候选项容器类名
  placeholder: { type: String },
  modelValue: { type: String, required: true },
  animation: { type: Boolean, default: true },
  //* 过渡动画是否开启
  disabled: { type: Function },
  zIndex: { type: Number, default: 66 },
  width: { type: [String, Number], default: 264 },
  size: { type: String, default: "default" },
  mode: { type: String, default: "date" },
  name: { type: String }
};
const UiDatePickerEmits = {
  "update:modelValue": (_data) => true,
  "before-enter": () => true,
  "before-leave": () => true,
  "after-enter": () => true,
  "after-leave": () => true,
  "change": (_date) => true,
  "clear": () => true
};

export { UiDatePickerEmits, UiDatePickerPropsOption };
//# sourceMappingURL=component.mjs.map
